// Minimal AOS.js replacement for fade-up/fade-in
export function initAOS() {
  const els = document.querySelectorAll('[data-aos]');
  const onScroll = () => {
    els.forEach(el => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight - 40) {
        el.classList.add('aos-animate');
      }
    });
  };
  window.addEventListener('scroll', onScroll);
  window.addEventListener('resize', onScroll);
  onScroll();
}
